import { render, staticRenderFns } from "./BrandCatalogue.vue?vue&type=template&id=71beb964&scoped=true"
import script from "./BrandCatalogue.vue?vue&type=script&lang=js"
export * from "./BrandCatalogue.vue?vue&type=script&lang=js"
import style0 from "./BrandCatalogue.vue?vue&type=style&index=0&id=71beb964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71beb964",
  null
  
)

export default component.exports